const wsUrl = process.env.CLOUD_URL || 'wss://microcord.net:8444';
const cluster = process.env.CLUSTER || '00000000-0000-0000-0000-000000000000';
const configCloud = {
    ws: {
        url: wsUrl
    },
    cluster
};
export default configCloud;
